/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase2_Fix_Public_Tool_Rate_LimitedInputs */

const en_phase2_fix_public_tool_rate_limited = /** @type {(inputs: Phase2_Fix_Public_Tool_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many free runs right now. Try again in a minute.`)
};

const zh_hans1_phase2_fix_public_tool_rate_limited = /** @type {(inputs: Phase2_Fix_Public_Tool_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前免费运行次数过多，请一分钟后再试。`)
};

const pt_br2_phase2_fix_public_tool_rate_limited = /** @type {(inputs: Phase2_Fix_Public_Tool_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitas execuções grátis agora. Tente de novo em um minuto.`)
};

const es_phase2_fix_public_tool_rate_limited = /** @type {(inputs: Phase2_Fix_Public_Tool_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiadas ejecuciones gratis en este momento. Inténtalo de nuevo en un minuto.`)
};

const fr_phase2_fix_public_tool_rate_limited = /** @type {(inputs: Phase2_Fix_Public_Tool_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop d’exécutions gratuites en ce moment. Réessayez dans une minute.`)
};

const de_phase2_fix_public_tool_rate_limited = /** @type {(inputs: Phase2_Fix_Public_Tool_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade zu viele kostenlose Läufe. Versuch es in einer Minute erneut.`)
};

const ru_phase2_fix_public_tool_rate_limited = /** @type {(inputs: Phase2_Fix_Public_Tool_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сейчас слишком много бесплатных запусков. Повторите через минуту.`)
};

const it_phase2_fix_public_tool_rate_limited = /** @type {(inputs: Phase2_Fix_Public_Tool_Rate_LimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troppe esecuzioni gratuite al momento. Riprova tra un minuto.`)
};

/**
* | output |
* | --- |
* | "Too many free runs right now. Try again in a minute." |
*
* @param {Phase2_Fix_Public_Tool_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const phase2_fix_public_tool_rate_limited = /** @type {((inputs?: Phase2_Fix_Public_Tool_Rate_LimitedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase2_Fix_Public_Tool_Rate_LimitedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_phase2_fix_public_tool_rate_limited(inputs)
	if (locale === "pt-BR") return pt_br2_phase2_fix_public_tool_rate_limited(inputs)
	if (locale === "es") return es_phase2_fix_public_tool_rate_limited(inputs)
	if (locale === "fr") return fr_phase2_fix_public_tool_rate_limited(inputs)
	if (locale === "de") return de_phase2_fix_public_tool_rate_limited(inputs)
	if (locale === "ru") return ru_phase2_fix_public_tool_rate_limited(inputs)
	if (locale === "it") return it_phase2_fix_public_tool_rate_limited(inputs)
	return en_phase2_fix_public_tool_rate_limited(inputs)
});